import type { TProfileLead, TProfileLeadStatus } from '~/types/b2b'

export type TProfileLeadSortBy = 'date' | 'amount'
export type TProfileLeadSortDir = 'asc' | 'desc'

interface ProfileLeadsResponse {
  current_page: number
  data: TProfileLead[]
  last_page: number
  per_page: number
  total: number
  next_page_url: string | null
  prev_page_url: string | null
}

export const useProfileLeads = (
  statuses: Ref<TProfileLeadStatus[]>,
  page: Ref<number>,
  sortBy: Ref<TProfileLeadSortBy>,
  sortDir: Ref<TProfileLeadSortDir>
) => {
  const { getToken } = useUser()

  const params = computed(() => ({
    ...(statuses.value.length ? { status: statuses.value.join(',') } : {}),
    page: page.value,
    sort_by: sortBy.value,
    sort_dir: sortDir.value,
  }))

  const { data: raw, pending, error, refresh } = useApi<{ data: ProfileLeadsResponse }>('/profile/leads', {
    params,
    headers: computed(() => ({ Authorization: `Bearer ${getToken()}` })),
  })

  const leads = computed(() => raw.value?.data?.data ?? [])

  const meta = computed(() => {
    const d = raw.value?.data
    if (!d) return undefined
    return {
      current_page: d.current_page,
      last_page: d.last_page,
      per_page: d.per_page,
      total: d.total,
    }
  })

  const links = computed(() => ({
    prev: raw.value?.data?.prev_page_url ?? null,
    next: raw.value?.data?.next_page_url ?? null,
  }))

  return { leads, meta, links, pending, error, refresh }
}

